<template>
  <div class="dynamic-product-simple" @click="jump">
    <div v-if="productImage" class="product-image" :style="{'height': `${productImageHeight}px`}">
      <beast-image
        :lazy="true"
        :defaultImage="defaultImage"
        :src="productImage"
      />
      <div class="image-state" :style="{'height': `${productImageHeight}px`, 'top': `${-productImageHeight}px`}">
        <!-- <div class="corner-box" v-if="data.foretell">
          <img :src="cornerImg.foretell" class="stats-tag" alt="" />
        </div>
        <div class="corner-box" v-if="data.offShelf">
          <img :src="cornerImg.offshelf" class="stats-tag" alt="" />
        </div>
        <div class="corner-box" v-else-if="data.soldOut">
          <img :src="cornerImg.soldout" class="stats-tag" alt="" />
        </div> -->
        <div class="corner-box" v-if="data.foretell">
          <div class="stats-tag">
            <span>即将开售</span>
          </div>
        </div>
        <div class="corner-box" v-if="data.offShelf">
          <div class="stats-tag">
            <span>下架</span>
          </div>
        </div>
        <div class="corner-box" v-else-if="data.soldOut">
          <div class="stats-tag">
            <span>售罄</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="product-image">
      <img :src="defaultImage" />
    </div>
   
    <div class="product-infos" :class="{'hide-pad': hideInfoPadding}">
      <div class="summary" v-if="data.activityDesc">{{data.activityDesc}}</div>
      <div class="tag" v-if="data.customizable">定制</div>
      <div class="tag" v-else-if="data.isOversea">跨境商品</div>
      <div
        class="brand-name gro-book"
        v-if="productCondition.brandName === 'SHOW' && data.brand" 
      >{{data.brand && data.brand.name}}</div>
      <div
        class="name" 
        v-if="productCondition.productName !== 'HIDE'"
        :class="{'one': productCondition.productName === 'ONE', 'two': productCondition.productName === 'TWO'}"
      >{{data.name}}</div>
      <div class="price-box">
        <div
          class="prices" 
          :class="{'newn': data.newcomerTag}"
          v-if="productCondition.rawPrice !== 'HIDE' || productCondition.nowPrice !== 'HIDE'"
        >
          <div class="price discount-price gro-demi"
          v-if="productCondition.nowPrice !== 'HIDE'"> <price v-if="data.price" :data="data.price" /><span class="newn-tag">新人价</span></div>
          <del class="price raw-price grotesk" v-if="productCondition.rawPrice !== 'HIDE' && data.price < data.rawPrice"><price v-if="data.rawPrice" :data="data.rawPrice"/></del>
        </div>
        <div class="stock-warn" v-if="data.stockWarn">{{data.stockWarn || ''}}</div>
      </div>
      <div class="refund-box" v-if="data.refunds">
        <div class="refund">约返{{data.refunds | formatPrice}}元</div>
      </div>
    </div>
    <!-- <div class="refund" v-if="data.refunds">约返{{data.refunds | formatPrice}}元</div> -->
  </div>
</template>

<script>
  import price from '@/price'
  import beastImage from '@/components/image'
  import track from '@/track'
  // import { lazyload } from '@/lazyload'
  import browser from '@beastshop/browser'
  import { ensure_protocol } from '@beastshop/url-util'
  import { transformLink, trackSkip } from '@/link'
  import data from '../../activity/big-furniture/data';

  const defaultImage = ensure_protocol("http://img.thebeastshop.com/images/mcatlog/banner/p.png")
  const cornerImg = {
    foretell: ensure_protocol("http://img.thebeastshop.com/app/list/foretell.png"),
    offshelf: ensure_protocol("http://img.thebeastshop.com/app/list/offshelf.png"),
    soldout: ensure_protocol("http://img.thebeastshop.com/app/list/soldout.png")
  }


  export default {
    name: 'list-v1',

    props: {
      data: {
        require: true
      },
      index: {
        type: Number,
        default: 0
      },
      productCondition: {
        type: Object,
        default: {}
      },
      miniEnv: {
        default: false
      },
      productImageHeight: {
        type: Number,
        default: 0
      },
      hideInfoPadding: {
        type: Boolean,
        default: false
      }
    },

    data: function () {
      return {
        defaultImage: defaultImage,
        productData: this.data,
        cornerImg: cornerImg
      }
    },

    components: {
      price,
      beastImage
    },

    mounted () {
    },

    watch: {
      data (d) {
        if (typeof d === 'object') {
          // this.fit()
        }
      }
    },

    filters: {
      formatPrice (value) {
        let v = String(Math.floor(value*Math.pow(10,1)) / Math.pow(10,1))
        const temp = v.split('.')
        return temp.length > 1 
          ? v
          : `${v}.0`
      }
    },

    computed: {
      productImage () {
        const data = this.data
        return data.featureImage
          ? data.featureImage
          : data.images
            ? data.images[0]
            : ''
      }
    },
    methods: {
      jump (e) {
        // const tar = e.currentTarget
        // const pindex = tar.dataset.index
        const pindex = this.index
        console.log(pindex, '#########index')

        if(!this.data || !this.data.id) {
          return
        }

        this.$emit('product-simple', this.data, pindex)

        const link = transformLink({
          link: {
            type: "product",
            value: this.data.id
          },
          isMini: this.miniEnv
        })

        const trackData = {
          trackData: {
            name: this.source === 'CART' ? 'cart-suggest-product-more' : 'click-result',
            attrs: {
              value: this.data.id,
              index: pindex
            }
          },
          link,
          isMini: this.miniEnv
        }

        trackSkip(trackData)
      },

      fit () {
        const tagItem = document.querySelectorAll('.prices')
        const tagArr = Array.from(tagItem)
        tagArr.forEach(elem => {
          const discount = elem.querySelector('.discount-price')
          const rawcount = elem.querySelector('.raw-price')
          const tags = elem.querySelector('.tags-wrap')

          const dw = discount && discount.clientWidth || 0
          const rw = rawcount ? rawcount.clientWidth : 0
          const tw = tags && tags.clientWidth || 0

          if ((dw + rw + tw) > elem.clientWidth) {
            tags.style.display = 'none'
          }
        })
      }
    }
  }
</script>

<style scoped lang="stylus">
@import '../../common/styl/global.styl'

.dynamic-product-simple
  font-size rem(12)
  color #000000
  .product-image
    width 100%
    // height rem(195)
    margin-bottom rem(10)
    img
      width 100%
      height 100%
    .image-state
      position relative
      // top rem(-195)
      left 0
      width 100%
      // height rem(195)
      .foretell-box
        position absolute
        top rem(6)
        right rem(6)
        width rem(35)
        height rem(35)
        box-sizing border-box
        border rem(1.5) solid #000000
        .foretell
          position relative
          width 100%
          top 50%
          transform translateY(-50%)
          font-size rem(10)
          line-height rem(14)
          font-weight bold
          text-align center
      .corner-box
        position absolute
        top 0
        right 0
        left 0
        bottom 0
        background rgba(255, 255, 255, .5) none repeat scroll !important
        overflow hidden
        .stats-tag
          position absolute
          top rem(6)
          right rem(6)
          width rem(35)
          height rem(35)
          border solid rem(1.5) #000
          font-size rem(10)
          font-weight bold
          text-align center
          background #fff
          color #000
          span
            display inline-block
            position absolute
            width rem(25)
            top 50%
            left 50%
            transform translate(-50%, -50%)
      // .corner-box
      //   position absolute
      //   top 0
      //   right 0
      //   left 0
      //   bottom 0
      //   background rgba(255, 255, 255, .6) none repeat scroll !important
      //   overflow hidden
      //   .stats-tag
      //     height auto !important
        // .stats-tag
        //   position absolute
        //   top rem(6)
        //   right rem(6)
        //   width rem(35)
        //   height rem(35)
        //   border rem(1.5) solid #000000
        //   font-size rem(10)
        //   font-weight bold
        //   text-align center
        //   background #ffffff
        //   span
        //     display inline-block
        //     position absolute
        //     width rem(22)
        //     top 50%
        //     left 50%
        //     transform translate(-50%, -50%)
        //   &.big
        //     width rem(50)
        //     height rem(50)
        //     border solid rem(2) #000
        //     font-size rem(14)
        //     span
        //       width rem(31)
  .product-infos
    width 100%
    // padding 0 rem(12)
    box-sizing border-box
    line-height rem(17)
    padding-left rem(15)
    clearfix()
    &.hide-pad
      padding-left 0
    .summary
      ellipsis()
      font-weight bold
      color #C44747
      margin-bottom rem(3)
    .tag
      ellipsis()
      font-weight bold
    .brand-name
      ellipsis()
      line-height rem(17)
    .name
      &.one
        ellipsis()
      &.two
        overflow hidden
        text-overflow ellipsis
        display -webkit-box
        -webkit-line-clamp 2
        -webkit-box-orient vertical
    .price-box
      clearfix()
    .prices
      float left
      margin-top rem(3)
      ellipsis()
      clearfix()
      width auto!important
      &.newn
        .price
          .newn-tag
            display inline-block
            width rem(42)
            height rem(17)
            margin-left rem(5)
            font-size rem(10)
            font-weight bold
            line-height rem(17)
            border-radius rem(2)
            text-align center
            background #F5F5F5
            color #DD4F14
            &::before
              content ''
              display inline-block
              vertical-align middle
              width 0
              height 100%
              margin-top rem(1)
        .raw-price
          display block
          margin-left 0
      .price
        font-size rem(13)
        // float left
        display inline-block
        line-height rem(16)
        .newn-tag
          display none
        .decimal
          font-size rem(10)
      .raw-price
        color #C9C9C9
        font-size rem(11)
        // float left
        display inline-block
        line-height rem(16)
        margin-left rem(8)
  .stock-warn
    // float left
    // padding-top rem(3)!important
    margin-left rem(6)
    font-weight bold
    font-size rem(10)
    color #c44747
  .refund-box
    .refund
      display inline-block
      margin-left 0
      // display block
      // margin-left rem(15)
      margin-top rem(5)
      padding rem(3) rem(5)
      border solid rem(1) #C44747
      font-size rem(10)
      font-weight bold
      color #C44747
</style>



// WEBPACK FOOTER //
// index.vue?fa29eb7e